import { Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { OxancefrService } from 'src/lib/services/oxancefr.service';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { Me } from 'src/lib/services/me.service';
import { DemandeNewComponent } from '../../demandes/demande-new.component';
import { baseAnimation } from 'src/lib/animations';
import { MicrosoftPowerBIService } from 'src/lib/services/microsoftPowerBI.service';
import { decodeEntities } from '@wordpress/html-entities';
import { ActivatedRoute } from 'src/lib/services/activated-route.service';
import { MicrosoftService } from 'src/lib/services/microsoft.service';
import { LaboService } from '@lib/services/labo.service';
import { MatIntro } from '@lib/modules/mat-intro/mat-intro.module';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: baseAnimation
})
export class HomeComponent implements OnDestroy {

	private subscriptions: Subscription = new Subscription();

	@ViewChild('readMoreTemplate') readMoreTemplateRef: TemplateRef<HTMLElement>;

	applications: any[] = [];

    socials: {[key: string]: string} = {
        facebook: 'https://www.facebook.com/OxanceSante',
        twitter: 'https://twitter.com/oxancesante',
        linkedIn: 'https://www.linkedin.com/company/oxance/mycompany',
        youtube: 'https://www.youtube.com/channel/UCJ5sZ_g-GiVrNpPmP0X7HdQ',
        instagram: 'https://www.instagram.com/oxancesante'
    };

	postsActu: any[];

	params = {
		_fields: 'id,title,excerpt,content,date,status,link,_embedded,_links',
		_embed: 'author,wp:featuredmedia,wp:term'
	};

    demandesIntroReplay = this.intro.need('demandes-new', () => import('../../../guides/demandes-new.guide').then(m => m.default));
    profileEditIntroReplay = this.intro.need('profile-edit', () => import('../../../guides/profile-edit.guide').then(m => m.default));

	constructor(public me: Me,
				private activatedRoute: ActivatedRoute,
				private microsoftService: MicrosoftService,
				private powerBIService: MicrosoftPowerBIService, 
				private oxancefrService: OxancefrService,
				private laboService: LaboService,
				private dialog: MatDialog,
                private intro: MatIntro,
                private elementRef: ElementRef) {

		this.applications = [

			{name: 'Cosium', picture: 'assets/launch-cosium.webp', actions: [{url: 'https://c1.cosium.biz/01EVAO06192'}]},
			{name: 'Veasy', picture: 'assets/launch-veasy.svg', actions: [{url: 'https://patient.visiodent.com'}]},
			{name: 'Prise de RDV', picture: 'assets/launch-doctolib.svg', actions: [{url: 'https://pro.doctolib.fr'}]},
			{name: 'Cediacte', picture: 'assets/launch-cediacte.svg', actions: [
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADNICE', label: 'SSIAD / SAD NICE'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADDRAP', label: 'SSIAD DRAP'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADCARROS', label: 'SSIAD CARROS'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADPSL', label: 'SSIAD PORT SAINT LOUIS'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADMARTIGUES', label: 'SSIAD MARTIGUES'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADSTANTOINE', label: 'SSIAD SAINT ANTOINE'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADLAFEUILLERAIE', label: 'SSIAD LA FEUILLERAIE'},
				{url: 'https://cediacte.oxance.fr/cediacte/FAMMDI', label: 'FAM MDI'},
				{url: 'https://cediacte.oxance.fr/cediacte/MASLEPREVERT', label: 'MAS LE PRE VERT'},
				{url: 'https://cediacte.oxance.fr/cediacte/MASSAINTISMIER', label: 'MAS SAINT ISMIER'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIAD38', label: 'SSIAD GRENOBLE'},
				{url: 'https://cediacte.oxance.fr/cediacte/SSIADEMSIS', label: 'EMSIS GRENOBLE'},
				{url: 'https://cediacte.oxance.fr/CediActe/MASVALJEANNEROSE', label: 'MAS VAL JEANNE ROSE'},
				{url: 'https://cediacte.oxance.fr/CediActe/MASCANOPE', label: 'MAS CANOPEE'},
				{url: 'https://cediacte.oxance.fr/cediacte/MASCOTEPARC', label: 'MAS COTE PARC'}
			]},
			{name: 'Airmes', picture: 'assets/launch-airmes.webp', actions: [{url: 'https://www.airmes-application.eu'}]},
			{name: 'Livia', picture: 'assets/launch-keopss.webp', actions: [{url: 'https://door.livia-parcoursdevie.fr/fr/login/authentification'}]},
			{name: 'Familizz', picture: 'assets/launch_familizz.png', actions: [{url: 'https://familizz.oxance.fr'}]},
			{name: 'Titanlink', picture: 'assets/launch_titanlink.svg', actions: [{url: 'https://oxance.titanlink.eu/TW_15200'}]},
			{name: 'Eolia', picture: 'assets/launch-eolia.webp', actions: [{url: 'https://cloud.eolia-software.com/Recrutement'}]},
			{name: 'Kélio', picture: 'assets/launch-bodet.webp', actions: [{url: 'https://oxance.kelio.io'}]},
			{name: 'Notilus', picture: 'assets/launch-notilus.webp', actions: [{url: 'https://oxance.notilus-tne.cegid.cloud'}]},

			...(this.powerBIService.isAuthenticated ? [
				{name: 'PowerBI', svgIcon: 'powerbi-oxance', actions: [{link: '/bi'}]},
			]: []),

			{name: 'Outlook', svgIcon: 'outlook', actions: [{url: 'https://outlook.office.com'}]},
			{name: 'Teams', svgIcon: 'teams', actions: [{url: 'https://teams.microsoft.com/'}]},

			...(this.microsoftService.isAuthenticated ? [
				{name: 'Documents', icon: 'folder_shared', class: 'mat-accent-gradient', actions: [{link: '/drive'}]},
			]: []),

			{name: 'Cegedim Marseille', picture: 'assets/launch-rdp.webp', actions: [{url: '/api/drive/public/01UZ4LSVQKEG4MNFBAF5FZBTQP4I3AB723'}]},
			{name: 'Cegedim Manosque', picture: 'assets/launch-rdp.webp', actions: [{url: '/api/drive/public/01UZ4LSVV5NFFZI6IESNB3QY53SCKWW26M'}]},
        ];

		this.subscriptions.add(
            this.activatedRoute.params.subscribe(params => {
                const element = this.elementRef.nativeElement.querySelector(`#${params?.slug ?? 'top'}`);
                setTimeout(() => element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'}), 0);
			})
		);

		forkJoin([
            this.laboService.requestsAsync([
                {url: 'posts', options: {params: {categories: 151, status: 'publish', ...this.params}}},
                {url: 'posts', options: {params: {categories: 151, status: 'draft', ...this.params}}}
            ]),
            this.oxancefrService.requestsAsync([
                {url: 'posts', options: {params: {categories: 368, status: 'private,publish', ...this.params}}}
            ])
        ]).subscribe(([{response: laboResponse}, {response: oxancefrResponse}]) => {

            laboResponse = laboResponse.map(post => ({
				title: post.status === 'draft' ?
                    'Nouveautés du Portail à venir...':
                    `Mise à jour du Portail v${decodeEntities(post.title.rendered.replace(/^Privé\s:\s/gi, ''))}`,
				// description: decodeEntities(post.excerpt.rendered),
				// content: decodeEntities(post.content.rendered),
				date: moment(post.date),
				status: post.status,
                routerLink: `/labo/${post.id}`,
				featuredMediaUrl: post._embedded['wp:featuredmedia']?.first.media_details.sizes['tuto-medium']?.source_url ??
                                  post._embedded['wp:featuredmedia']?.first.media_details.sizes['tuto-small']?.source_url ??
                                  'assets/236.svg'
			}));

            oxancefrResponse = oxancefrResponse.map(post => ({
				title: decodeEntities(post.title.rendered.replace(/^Privé\s:\s/gi, '')),
				// description: decodeEntities(post.excerpt.rendered),
				// content: decodeEntities(post.content.rendered),
				date: moment(post.date),
				status: post.status,
				link: post.link,
				featuredMediaUrl: post._embedded['wp:featuredmedia']?.first.media_details.sizes.news_thumb.source_url ?? 'assets/236.svg'
			}));

            this.postsActu = [...laboResponse, ...oxancefrResponse].sort((a, b) => b.date.valueOf() - a.date.valueOf());
        });
	}

	readMore (post: any) {
		this.dialog.open(this.readMoreTemplateRef, {data: {post}, width: '1080px'});
	}

	postIndex (index: number): number { return index; }

	openDemande () {
		this.dialog.open(DemandeNewComponent, {width: '1080px'});
	}

    originalOrder (): number { return 0 }

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
